import React from 'react';
import { observer } from 'mobx-react';
import { Item, Content, Info, Label, Editor } from '../Item';
import TextElem from '../../../../components/Text';
import Input from '../Input';
import styles from './Text.m.sass';
import { answerToString } from '../../../../utils/questionUtil';
var Text = function Text(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    readOnly = _ref.readOnly,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    disabled = _ref.disabled,
    checkout = _ref.checkout;
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout,
    title: question.description
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, readOnly ? /*#__PURE__*/React.createElement("div", {
    className: styles.response
  }, /*#__PURE__*/React.createElement(TextElem, null, answerToString(question, answer))) : /*#__PURE__*/React.createElement(Input, {
    type: "text",
    placeholder: "Text...",
    value: answer || '',
    onChange: onChange,
    onBlur: onUpdate,
    disabled: disabled,
    multi: true
  }))));
};
export default observer(Text);
//# sourceMappingURL=index.js.map
